var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7612 21.4926C22.9045 21.36 23 21.1833 23 21.0065V5.2292C23 4.83146 22.6418 4.5 22.2119 4.5H7.78806C7.35821 4.5 7 4.83146 7 5.2292V22.4207C7 23.5476 7.9791 24.4536 9.19701 24.4536H9.79403V23.172H9.19701C8.74328 23.172 8.38507 22.8405 8.38507 22.4207C8.38507 22.0009 8.74328 21.6473 9.19701 21.6473H10.6299V25.1828C10.6299 25.4259 10.9403 25.5806 11.1552 25.448L12.1821 24.8072C12.3015 24.7409 12.4448 24.7409 12.5642 24.8072L13.591 25.448C13.806 25.5806 14.1164 25.448 14.1164 25.1828V21.6473H21.0657C20.994 21.8683 20.9224 22.1334 20.9224 22.4207C20.9224 22.708 20.9701 22.951 21.0657 23.172H14.9522V24.4536H22.3075C22.594 24.4536 22.8328 24.2989 22.9522 24.0338C23.0478 23.7907 22.9761 23.5034 22.7612 23.3267C22.7612 23.3267 22.3075 22.9289 22.3075 22.3986C22.3075 22.1334 22.4269 21.9125 22.5224 21.7357C22.6418 21.581 22.7612 21.4926 22.7612 21.4926Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ7);
export default __webpack_public_path__ + "static/media/q7.2c8bd6134f4778c753351ba3bf036f57.svg";
export { ForwardRef as ReactComponent };